import { each } from 'lodash';

const letterMapping = {
  TCH: 'Չ',
  OUN$: 'ՅՈՒՆ',
  IAN$: 'ԻԱՆ',
  YAN$: 'ՅԱՆ',
  '^YE': 'Ե',
  '^VO': 'Ո',
  EH$: 'ԵՀ',
  SH: 'Շ',
  PH: 'Ֆ',
  KH: 'Խ',
  GH: 'Ղ',
  OU: 'ՈՒ',
  CH: 'Չ',
  ZH: 'Ժ',
  DZ: 'Ձ',
  TH: 'Թ',
  TS: 'Ց',
  Tsh: 'Ճ',
  Tch: 'Չ',
  '^Ye': 'Ե',
  '^Vo': 'Ո',
  Eh$: 'ԵՀ',
  Sh: 'Շ',
  Ph: 'Ֆ',
  Kh: 'Խ',
  Gh: 'Ղ',
  Ou: 'ՈՒ',
  Ch: 'Չ',
  Zh: 'Ժ',
  Dz: 'Ձ',
  Th: 'Թ',
  Ts: 'Ց',
  tsh: 'ճ',
  tch: 'ճ',
  oun$: 'յուն',
  ian$: 'իան',
  yan$: 'յան',
  '^ye': 'ե',
  '^vo': 'ո',
  eh$: 'եհ',
  sh: 'շ',
  ph: 'ֆ',
  kh: 'խ',
  gh: 'ղ',
  ou: 'ու',
  ch: 'չ',
  zh: 'ժ',
  dz: 'ձ',
  ts: 'ց',
  th: 'թ',
  ev: 'և',

  A: 'Ա',
  B: 'Բ',
  C: 'Ց',
  D: 'Դ',
  E: 'Ե',
  F: 'Ֆ',
  G: 'Գ',
  H: 'Հ',
  I: 'Ի',
  J: 'Ջ',
  K: 'Կ',
  L: 'Լ',
  M: 'Մ',
  N: 'Ն',
  '^O': 'Օ',
  O: 'Ո',
  P: 'Պ',
  Q: 'Ք',
  '^R': 'Ռ',
  R: 'Ր',
  S: 'Ս',
  T: 'Տ',
  U: 'ՈՒ',
  V: 'Վ',
  W: 'Վ',
  X: 'ՔՍ',
  Y$: 'Ի',
  Y: 'Յ',
  Z: 'Զ',

  a: 'ա',
  b: 'բ',
  c: 'ց',
  d: 'դ',
  e: 'ե',
  f: 'ֆ',
  g: 'գ',
  h: 'հ',
  i: 'ի',
  j: 'ջ',
  k: 'կ',
  l: 'լ',
  m: 'մ',
  n: 'ն',
  '^o': 'օ',
  o: 'ո',
  p: 'պ',
  q: 'ք',
  '^r': 'ռ',
  r: 'ր',
  s: 'ս',
  t: 'տ',
  u: 'ու',
  v: 'վ',
  w: 'վ',
  x: 'քս',
  y$: 'ի',
  y: 'յ',
  z: 'զ',


  '\\-': '-',
  ' ': ' ',
  '': '',
  '\\.': '.',
};

const getArmName = (value) => {
  if (!value) {
    return '';
  }
  let armName = value.slice();
  each(letterMapping, (am, en) => {
    armName = armName.replace(new RegExp(en, 'g'), am);
  });

  return armName;
};

export default getArmName;
